module.exports = __webpack_public_path__ + "img/text-and-image-default.2453d5b0.svg";